import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import logo from "../../assets/logo spartnerg.png";
import "./NavBar.css";

const NavBar = () => {
  const [showNav, setShowNav] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(window.scrollY);

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY > lastScrollY) {
      setShowNav(false); // Oculta al bajar
    } else {
      setShowNav(true); // Muestra al subir
    }
    setLastScrollY(currentScrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  return (
    <div className={`navBar ${showNav ? 'visible' : 'hidden'}`}>
      <div className="navBarIzq gap-2">
        <div className="navBar__logo cogno-logo-navbar">
          <Link to="/home" style={{ textDecoration: 'none' }}>
            <img src={logo} alt="cognoseguridad" />
          </Link>
        </div>
      </div>
      
      <div className="navBar__links gap-3">
        <Link to="/home#homeAboutUs">Sobre nosotros</Link>
        <Link to="/home#homeMAndV">Mision y vision</Link>
        <Link to="/home#homeAllies">Asociados</Link>
        <Link to="/home#contact">Contactanos</Link>
      </div>
    </div>
  );
};

export { NavBar };

